import React from 'react';
import { Container, Typography } from '@mui/material';
import EmployeesManagement from '../components/admin/EmployeesManagement';
import { useTranslation } from 'react-i18next';

const UsersPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        {t('admin.usersManagement')}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {t('admin.usersManagementDescription')}
      </Typography>
      <EmployeesManagement />
    </Container>
  );
};

export default UsersPage;



